import http from "@/common/http.service";
const ROOT_URL = "domain/list";
const DELETE_URL = "domain/delete";
const AUTHENTICATE_URL = "domain/authenticate";
const USER_SAVE = "domain/save";
const DNS_RECORD_URL = "domain/getDomainDnsRecord";
const DOMAIN_LOOKUP_URL = "domain/lookup";
export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then(function (response) {
      var responseData = response.data.data;
      responseData.forEach((item) => {
        if (item.domain_name.startsWith("mc.")) {
          item.domain_name = item.domain_name.replace("mc.", "");
        }
      });
      var data = { items: responseData, total: response.data.totalRows };
      cb(data);
    });
  },

  delete(id) {
    return http.post(DELETE_URL, { id: id });
  },
  getDomainDnsRecord(id) {
    return http.post(DNS_RECORD_URL, { id: id });
  },
  fetchDomainLookup() {
    return http.post(DOMAIN_LOOKUP_URL, {});
  },
};

export const saveDomain = (params) => {
  return http.post(USER_SAVE, params);
};

export const authenticateDomain = (id, val) => {
  return http.post(AUTHENTICATE_URL, { id: id, isAdded: val });
};
